import Lock from "mdi-material-ui/Lock";
import moment from "moment";
import React from "react";

import Content from "../../../shared/NotificationsDrawer/NotificationViewTab/partials/Content";
import Subheader from "../../../shared/NotificationsDrawer/NotificationViewTab/partials/Subheader";

import withNotificationMarkedRead from "./withNotificationMarkedRead";

function JobCastLocked({
  notification: {
    attributes: { messageBody, createdAt },
  },
  jobcast: {
    attributes: {
      individualAvatar,
      individualFirstName,
      individualLastInitial,
      organizationName,
    },
  },
}) {
  return (
    <div>
      <Subheader
        leftChip={{
          chipHeader: "Update from",
          individualFirstName,
          individualLastInitial,
          individualAvatar,
          chipSubText: organizationName,
        }}
      />
      <Content
        iconImage={Lock}
        iconCaption="Locked"
        label="Lock Reason"
        value={messageBody}
        helperText={moment(createdAt).format("MMMM Do, YYYY")}
      />
    </div>
  );
}

export default withNotificationMarkedRead(JobCastLocked);
